import * as THREE from 'three'
import GSAP from 'gsap'
import Experience from '../Experience'

export default class Events {
  constructor() {
    //setup
    this.experience = new Experience()
    this.camera = this.experience.camera
    this.controls = this.camera.controls
    this.resources = this.experience.resources
    //Methods
    this.setCamera()
  }
  setCamera() {
    //set camera on load
    const btn = document.querySelector('.loader .start')
    btn.addEventListener('click', () => {
      GSAP.from(this.camera.instance.position, { x: 0, y: 2, z: 22, duration: 3, ease: 'Power1.easeOut' })
    })
  }
}
